import axios from "axios";
import config from "./config";

const client = axios.create({});

client.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        const errorResponse = JSON.parse(JSON.stringify(error));
       
        return Promise.reject(error);
    }
);

// const axiosClient = (
//     endpoint,
//     payload = {},
//     method = "get",
//     headers = {}
   
// ) => {
//     console.log(endpoint)
    
//     let axiosConfig = {
//         method: method.toLowerCase(),
//          headers: {
//                 'Content-Type': 'application/json',
//                 'Authorization':''
//             },
//             dataType: 'json'
//     };
//     if (
        
//         endpoint !== "registerUser" &&
//         endpoint !== "eventsGet"
//     ) {
        
//         axiosConfig.headers["Authorization"] = `Bearer ${headers}`;
//     }
//     if (method.toLowerCase() === "get") {
//         axiosConfig.params = payload;
//     } else {
//         // If payload is FormData, use it directly; otherwise, assume it's a regular object
//         axiosConfig.data = payload instanceof FormData ? payload : payload;
//     }

//     return client(`${config.ApiURL}${endpoint}`, axiosConfig);
// };
const axiosClient = (endpoint, payload = {}, method = "get", headers = {}) => {
    let axiosConfig = {
        method: method.toLowerCase(),
        headers: {
            'Authorization': `Bearer ${headers}`
        }
    };

    if (payload instanceof FormData) {
        axiosConfig.data = payload;
        // Let Axios set the correct Content-Type (multipart/form-data)
    } else {
        axiosConfig.data = payload;
        axiosConfig.headers['Content-Type'] = 'application/json';
    }

    return client(`${config.ApiURL}${endpoint}`, axiosConfig);
};

export default axiosClient;